import { useState, useEffect } from "react";
import { getAvailablePaymentGateways, PaymentGateway } from "../actions/getAvailablePaymentGateways.actions";

interface UseAvailablePaymentGatewaysReturn {
  gateways: PaymentGateway[];
  isLoading: boolean;
  error: Error | null;
}

export const useAvailablePaymentGateways = (): UseAvailablePaymentGatewaysReturn => {
  const [gateways, setGateways] = useState<PaymentGateway[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchGateways = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getAvailablePaymentGateways();
        setGateways(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Failed to fetch payment gateways"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchGateways();
  }, []);

  return { gateways, isLoading, error };
};
